import React from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import ModalCloseButton from "components/ModalCloseButton";
import { __ } from "services/Translator";

/**
 * The one renderer for every admin-configured pop-up (exit intent, registration
 * abandonment, post-login bonus reminder). It is purely presentational: it takes
 * a normalized pop-up from utils/popups and paints image / title / body lines /
 * one button. It decides nothing about when to show — the caller has already
 * cleared the frequency cap.
 */
export default function ConfigurablePopup({ popup, show, onClose, onAction }) {
  const history = useHistory();

  if (!popup) return null;

  const handleAction = () => {
    const url = popup.buttonUrl;
    onClose?.();
    // A pop-up with no button_url just closes.
    if (!url) return;
    // The caller may own the destination (the exit-intent CTA opens the sign-up
    // modal rather than routing), and says so by returning true.
    if (onAction?.(url) === true) return;
    if (url.startsWith("/")) {
      history.push(url);
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal
      show={Boolean(show)}
      onHide={onClose}
      centered
      className={"config-popup-modal config-popup-modal--" + popup.type}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="config-popup">
        <ModalCloseButton onClick={onClose} className="config-popup__close modal_close_reg small" />

        {popup.imageUrl ? (
          <img className="config-popup__image" src={popup.imageUrl} alt="" />
        ) : null}

        {popup.title ? <h2 className="config-popup__title">{__(popup.title)}</h2> : null}

        {popup.bodyLines.length ? (
          <div className="config-popup__body">
            {popup.bodyLines.map((line, i) => (
              <p key={i} className="config-popup__line">
                {__(line)}
              </p>
            ))}
          </div>
        ) : null}

        <div className="config-popup__actions">
          <button type="button" className="config-popup__button" onClick={handleAction}>
            {__(popup.buttonText || "Close")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
